var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceivedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x35_35_x2C__Box_x2C__delivery_x2C__product_x2C__shipping",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.566,
    height: 70.156,
    viewBox: "0 0 57.566 70.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_11006",
    x: 9.347,
    y: 35.983,
    width: 48.219,
    height: 34.173,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9374",
    "data-name": "Group 9374",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9373",
    "data-name": "Group 9373",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11056",
    "data-name": "Path 11056",
    d: "M91.015,182.93l1.1-2.93H58.907l1.1,2.93H55l6.837,4.883V206.37H89.184V187.813l6.837-4.883Z",
    transform: "translate(-47.397 -162.434)",
    fill: "#febe76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11057",
    "data-name": "Path 11057",
    d: "M125,272.111V260h27.347v15.139H125Z",
    transform: "translate(-110.56 -234.621)",
    fill: "#c18e5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11058",
    "data-name": "Path 11058",
    d: "M60.005,210l1.831,4.883L55,210Z",
    transform: "translate(-47.397 -189.504)",
    fill: "#c69a75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11059",
    "data-name": "Path 11059",
    d: "M411.837,210,405,214.883,406.831,210Z",
    transform: "translate(-363.213 -189.504)",
    fill: "#c69a75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11060",
    "data-name": "Path 11060",
    d: "M125,410h27.347v3.907H125Z",
    transform: "translate(-110.56 -369.97)",
    fill: "#cda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11061",
    "data-name": "Path 11061",
    d: "M128.207,180l-1.1,2.93-1.831,4.883H97.93L96.1,182.93,95,180h33.207Z",
    transform: "translate(-83.49 -162.434)",
    fill: "#cda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11064",
    "data-name": "Path 11064",
    d: "M125.542,73.911A5.373,5.373,0,1,1,120.372,70,5.381,5.381,0,0,1,125.542,73.911Z",
    transform: "translate(-91.124 -42.667)",
    fill: "#a4d574"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9372",
    "data-name": "Group 9372",
    transform: "translate(43.741 27.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11065",
    "data-name": "Path 11065",
    d: "M426.667,280.286a.976.976,0,1,1-.691-.286A.974.974,0,0,1,426.667,280.286Z",
    transform: "translate(-425 -280)",
    fill: "#73665c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11066",
    "data-name": "Path 11066",
    d: "M426.667,310.286a.976.976,0,1,1-.691-.286A.974.974,0,0,1,426.667,310.286Z",
    transform: "translate(-425 -307.07)",
    fill: "#73665c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11067",
    "data-name": "Path 11067",
    d: "M426.667,340.286a.976.976,0,1,1-.691-.286A.974.974,0,0,1,426.667,340.286Z",
    transform: "translate(-425 -334.14)",
    fill: "#73665c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11068",
    "data-name": "Path 11068",
    d: "M426.667,370.286a.976.976,0,1,1-.691-.286A.974.974,0,0,1,426.667,370.286Z",
    transform: "translate(-425 -361.21)",
    fill: "#73665c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11069",
    "data-name": "Path 11069",
    d: "M426.667,400.286a.976.976,0,1,1-.691-.286A.974.974,0,0,1,426.667,400.286Z",
    transform: "translate(-425 -388.28)",
    fill: "#73665c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11076",
    "data-name": "Path 11076",
    d: "M54.767,291.953h-8.79a.977.977,0,0,1,0-1.953h8.79a.977.977,0,0,1,0,1.953Z",
    transform: "translate(-38.373 -261.691)",
    fill: "#3c3b3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11077",
    "data-name": "Path 11077",
    d: "M91.837,321.953h-5.86a.977.977,0,0,1,0-1.953h5.86a.977.977,0,0,1,0,1.953Z",
    transform: "translate(-74.467 -288.761)",
    fill: "#3c3b3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11078",
    "data-name": "Path 11078",
    d: "M47.93,351.953H45.977a.977.977,0,0,1,0-1.953H47.93a.977.977,0,0,1,0,1.953Z",
    transform: "translate(-38.373 -315.831)",
    fill: "#3c3b3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11079",
    "data-name": "Path 11079",
    d: "M95.743,371.953H85.977a.977.977,0,0,1,0-1.953h9.767a.977.977,0,1,1,0,1.953Z",
    transform: "translate(-74.467 -333.877)",
    fill: "#3c3b3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11080",
    "data-name": "Path 11080",
    d: "M147.93,86.836a.976.976,0,0,1-.813-.435l-1.953-2.93a.977.977,0,1,1,1.625-1.084l1.427,2.141,7.009-4.381A.977.977,0,0,1,156.26,81.8l-7.814,4.883A.972.972,0,0,1,147.93,86.836Z",
    transform: "translate(-118.193 -51.69)",
    fill: "#463836"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9375",
    "data-name": "Group 9375",
    transform: "translate(18.347 41.983)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -18.35, -41.98)",
    filter: "url(#Path_11006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11006-2",
    "data-name": "Path 11006",
    d: "M118.518,181.676l-3.558-3.664a5.228,5.228,0,0,0-3.751-1.586h-5.677a2.625,2.625,0,0,0-.014,5.25h-4.371a2.082,2.082,0,0,1-1.476-.61L93.51,174.9a2.25,2.25,0,0,0-3.183,0l-.048.048a2.184,2.184,0,0,0,0,3.089l10.541,10.539a6.274,6.274,0,0,0,4.436,1.837h14.6v-8.742Z",
    transform: "translate(-71.29 -132.26)",
    fill: "#fcc4ae"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11007",
    "data-name": "Path 11007",
    d: "M119.86,191.615H105.769a6.275,6.275,0,0,1-4.436-1.837L90.791,179.238a2.177,2.177,0,0,1-.634-1.678,2.183,2.183,0,0,0,.124,2.952l10.541,10.539a6.274,6.274,0,0,0,4.436,1.837h14.6Z",
    transform: "translate(-89.642 -176.715)",
    fill: "#f2ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11008",
    "data-name": "Path 11008",
    d: "M144.351,190.443h4.681v-.764h-4.171a2.624,2.624,0,0,1-2.407-3.672,2.623,2.623,0,0,0,1.9,4.436Z",
    transform: "translate(-128.458 -183.011)",
    fill: "#f2ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11009",
    "data-name": "Path 11009",
    d: "M149.677,189.926h-.255a1.528,1.528,0,0,1-1.528-1.528v-.256a1.528,1.528,0,0,1,1.528-1.528h.255a.509.509,0,0,1,.509.509v2.294A.509.509,0,0,1,149.677,189.926Z",
    transform: "translate(-133.055 -183.462)",
    fill: "#ffd2c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11010",
    "data-name": "Path 11010",
    d: "M209.547,207.128h5.141a1.274,1.274,0,0,0,1.274-1.274V194.432a1.274,1.274,0,0,0-1.274-1.274h-5.141a1.274,1.274,0,0,0-1.274,1.274v11.422A1.274,1.274,0,0,0,209.547,207.128Z",
    transform: "translate(-178.054 -188.34)",
    fill: "#d10028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11011",
    "data-name": "Path 11011",
    d: "M214.688,193.158h-1.274V204.58a1.274,1.274,0,0,1-1.274,1.274h-3.867a1.274,1.274,0,0,0,1.274,1.274h5.141a1.274,1.274,0,0,0,1.274-1.274V194.432A1.274,1.274,0,0,0,214.688,193.158Z",
    transform: "translate(-178.054 -188.34)",
    fill: "#b7022d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9376",
    "data-name": "Group 9376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11000",
    "data-name": "Path 11000",
    d: "M78.457,31.122,67.505,20.172A6.518,6.518,0,0,0,62.9,18.263H47.727v9.082h1.392l3.7,3.807a5.431,5.431,0,0,0,3.9,1.647h5.9a2.727,2.727,0,0,0,.015-5.454h4.541a2.163,2.163,0,0,1,1.534.634l6.4,6.4a2.338,2.338,0,0,0,3.307,0l.05-.05A2.27,2.27,0,0,0,78.457,31.122Z",
    transform: "translate(-39.739 -15.547)",
    fill: "#fcc4ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11001",
    "data-name": "Path 11001",
    d: "M78.457,31.122,67.505,20.172A6.518,6.518,0,0,0,62.9,18.263H47.727v1.323h14.64A6.519,6.519,0,0,1,66.976,21.5l10.952,10.95a2.262,2.262,0,0,1,.658,1.744A2.268,2.268,0,0,0,78.457,31.122Z",
    transform: "translate(-39.739 -15.547)",
    fill: "#f2ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11002",
    "data-name": "Path 11002",
    d: "M90.456,52.577H85.593v.794h4.333a2.726,2.726,0,0,1,2.5,3.815,2.725,2.725,0,0,0-1.971-4.609Z",
    transform: "translate(-67.585 -40.78)",
    fill: "#f2ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11003",
    "data-name": "Path 11003",
    d: "M99.635,56.38H99.9a1.588,1.588,0,0,1,1.588,1.588v.266A1.588,1.588,0,0,1,99.9,59.822h-.265a.529.529,0,0,1-.529-.529V56.909A.529.529,0,0,1,99.635,56.38Z",
    transform: "translate(-77.521 -43.577)",
    fill: "#ffd2c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11004",
    "data-name": "Path 11004",
    d: "M24.208,8H18.867a1.323,1.323,0,0,0-1.323,1.323V21.19a1.323,1.323,0,0,0,1.323,1.323h5.341a1.323,1.323,0,0,0,1.323-1.323V9.323A1.323,1.323,0,0,0,24.208,8Z",
    transform: "translate(-17.544 -8)",
    fill: "#377de2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11005",
    "data-name": "Path 11005",
    d: "M24.208,22.513H22.885V10.646a1.323,1.323,0,0,0-1.323-1.323H17.544A1.323,1.323,0,0,1,18.867,8h5.341a1.323,1.323,0,0,1,1.323,1.323V21.19A1.323,1.323,0,0,1,24.208,22.513Z",
    transform: "translate(-17.544 -8)",
    fill: "#2266d3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivedIcon);
export default __webpack_public_path__ + "static/media/received-icon.da95c837bde03aebaab184f074097418.svg";
export { ForwardRef as ReactComponent };